export default __webpack_public_path__ + "static/media/Band of Force.a11c8c5e.jpg";